/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface AutoRegionReference {
}

export enum AutoRegionReference_Enum {
  DEFAULT = 0,
  NORMALIZED_PREVIEW = 1,
  NORMALIZED_SENSOR = 2,
  RAW_SENSOR = 3,
  UNRECOGNIZED = -1,
}

export function autoRegionReference_EnumFromJSON(object: any): AutoRegionReference_Enum {
  switch (object) {
    case 0:
    case "DEFAULT":
      return AutoRegionReference_Enum.DEFAULT;
    case 1:
    case "NORMALIZED_PREVIEW":
      return AutoRegionReference_Enum.NORMALIZED_PREVIEW;
    case 2:
    case "NORMALIZED_SENSOR":
      return AutoRegionReference_Enum.NORMALIZED_SENSOR;
    case 3:
    case "RAW_SENSOR":
      return AutoRegionReference_Enum.RAW_SENSOR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AutoRegionReference_Enum.UNRECOGNIZED;
  }
}

export function autoRegionReference_EnumToJSON(object: AutoRegionReference_Enum): string {
  switch (object) {
    case AutoRegionReference_Enum.DEFAULT:
      return "DEFAULT";
    case AutoRegionReference_Enum.NORMALIZED_PREVIEW:
      return "NORMALIZED_PREVIEW";
    case AutoRegionReference_Enum.NORMALIZED_SENSOR:
      return "NORMALIZED_SENSOR";
    case AutoRegionReference_Enum.RAW_SENSOR:
      return "RAW_SENSOR";
    case AutoRegionReference_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseAutoRegionReference(): AutoRegionReference {
  return {};
}

export const AutoRegionReference = {
  encode(_: AutoRegionReference, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AutoRegionReference {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAutoRegionReference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): AutoRegionReference {
    return {};
  },

  toJSON(_: AutoRegionReference): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<AutoRegionReference>, I>>(base?: I): AutoRegionReference {
    return AutoRegionReference.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AutoRegionReference>, I>>(_: I): AutoRegionReference {
    const message = createBaseAutoRegionReference();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
